export enum SurveyStatusEnum {
    Draft = 1,
    Published = 2,
    Finished = 3
}


// WEBPACK FOOTER //
// ./src/constants/Enum/SurveyStatusEnum.tsx